import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    useProTableOt
} from "../../ui/ot";
import { useBlogCategory } from "../controller/blog_category_controller";
import BlogCategoryModal from "./blog_category_modal";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph, Text, Link } = Typography;
const BlogCategoryTable = ({
    showAllColumns = true,
    propsShowColumns,
    mode = "edit",
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const columns = [
        {
            title: "貼文分類",
            key: "name_language_data",
            dataIndex: "name_language_data",
            align: "center",
            disabled: true,
            render: (text, record, index) =>
                (record?.name_language_data || [])?.find(
                    (tmp) => tmp?.language_culture_code === "zh-tw"
                )?.language_culture_value || "-",
        },
        {
            title: "操作",
            valueType: "option",
            key: "option",
            fixed: "right",
            disabled: true,
            render: (text, record, _index) => {
                return (
                    <Row gutter={[4, 4]}>
                        <Col>
                            <Button
                                type="link"
                                onClick={() => {
                                    handleEditRow(record);
                                }}
                            >
                                修改
                            </Button>
                        </Col>
                        <Col>
                            <Popconfirm
                                title="刪除項目"
                                description="確定刪除勾選項目?"
                                onConfirm={() => handleDeleteRow(record?.category_id)}
                                onCancel={() => { }}
                            >
                                <Button type="danger" >
                                    刪除
                                </Button>
                            </Popconfirm>
                        </Col>
                    </Row>
                );
            },
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['blog_category_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value.category_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value.category_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record.category_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record.category_id);
                selectRow = selectRow.filter((row) => row.category_id !== record.category_id);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get");
    const navigate = useNavigate();

    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
        form.setValue('name_language_data', [
            {
                language_culture_code: "zh-tw",
                language_culture_value: "",
            },
        ]);

    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);

        // form.resetFields();
        let editRecord = { ...record }


        if (editRecord) {
            Object.keys(editRecord).forEach((key) => {
                if (key !== "key") {
                    form.setValue(key, editRecord[key]);
                }
            });
        }

    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    category_id: id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    category_id: val?.category_id,
                };
            });
        }
        if (data.length > 0) {
            deleteBlogCategoryData(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {
        let finalData = { ...values }
        finalData = {
            ...finalData,
        }
        if (axiosMode === "post") {
            postBlogCategoryData([finalData]);
        } else if (axiosMode === "patch") {
            patchBlogCategoryData([finalData]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });

    const {
        getBlogCategoryData,
        postBlogCategoryData,
        patchBlogCategoryData,
        deleteBlogCategoryData
    } = useBlogCategory({
        onFinish,
        onBefore,
    });

    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>
        <Col span={24}>
            <BlogCategoryModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={form}
                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
            />
        </Col>
        <Col span={24}>
            <ProTableOt
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={"category_id"}

                toolBarRender={() => {
                    if (mode === "edit") {
                        return [
                            <Button
                                size="sm"
                                onClick={() => {
                                    navigate('/officialweb/admin/articleManagement')

                                }} >
                                返回新增貼文
                            </Button>,
                            <Button
                                size="sm"
                                onClick={() => {
                                    handleAddRow()
                                }} >
                                新增貼文分類
                            </Button>,
                            <Popconfirm
                                title="刪除貼文分類"
                                description="確定刪除勾選的貼文分類?"
                                onConfirm={() => handleDeleteRow()}
                                onCancel={() => { }}
                            >
                                <Button
                                    type="primary"
                                    style={{
                                        color: "#000",
                                        backgroundColor: "#ffedee",
                                    }}
                                >
                                    刪除貼文分類
                                </Button>
                            </Popconfirm>,

                        ]
                    }
                    else {
                        return []
                    }
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get");
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return getBlogCategoryData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }
                }
                scroll={{
                    x: "100%",
                }}
            />
        </Col>
    </Row>)

}
const BlogCategory = () => {

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Typography.Title
                    level={3}
                >
                    貼文分類管理
                </Typography.Title>
                <BlogCategoryTable />
            </Col>
        </Row>
    );
};
export { BlogCategoryTable }
export default BlogCategory;
